import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=e8eada24"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports